const RouteNames = {
    INDEX: 'dmv-index',
    TEMPLATES: 'dmv-templates',
    OVERVIEW: 'dmv-overview'
}

export {
    RouteNames
}